<template>
  <button class="nav-toggle" @click="openNav">
    <icon-bars />
    <span class="nav-toggle__text">{{ $t('menu.title') }}</span>
  </button>
</template>

<script>
import { eventBus } from '@/main';
import IconBars from '../icons/IconBars';

export default {
  components: {
    IconBars
  },
  methods: {
    openNav () {
      eventBus.$emit('navOpened');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.nav-toggle {
  padding: 0;
  background: transparent;
  border: 0;
  outline: 0;
  color: $bodycolor-inverse;
  display: flex;
  align-items: center;
  cursor: pointer;
  &__text {
    font-size: $fs-s;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 0.5;
    margin-left: $sp-margin-smaller;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/topbar/NavToggle.vue